/**
 * @prettier
 * @flow
 */
import { useSelector as _useSelector } from 'react-redux';
import type { StateVm } from 'src/types/StateVm';

export function useSelector<T>(selector: (state: StateVm) => T, equalityFn?: (a: T, b: T) => boolean): $NonMaybeType<T> {
    return _useSelector(selector, equalityFn);
}
